import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { IonFooter } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-footer',
    standalone: true,
    imports: [CommonModule, IonFooter],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent {}
